import { HttpParams } from "@angular/common/http";

import { SortDirection } from "@core/enums/sort-type";
import { TableSorting } from "@custom-types/sorting";

export class SortingParams {
  static appendParams(sorting?: TableSorting): HttpParams {
    let params = new HttpParams({});
    if (sorting && sorting.direction) {
      switch (sorting.propertyName) {
        case "product":
          params = params.append("propertyName", "gfhProduct.Name");
          break;
        case "riskProfile":
          params = params.append(
            "propertyName",
            "riskProfile.ProfileDescription"
          );
          break;
        case "fundName":
          params = params.append("propertyName", "fund.Name");
          break;
        case "productName":
          params = params.append("propertyName", "productVersion.Product.Name");
          break;
        default:
          params = params.append("propertyName", sorting.propertyName);
      }
      const asc = sorting.direction === SortDirection.Ascending;
      params = params.append("asc", asc);
    }
    return params;
  }
}
